//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_EMPRESAS = "obtenerEmpresas";
export const OBTENER_EMPRESA = "obtenerEmpresa";
export const OBTENER_EMPRESA_DESCRIPCIONES = "obtenerEmpresaDescripciones";

export const REGISTAR_EMPRESA = "registrarEmpresa";
export const ACTUALIZAR_EMPRESA = "actualizarEmpresa";
// mutation types
export const SET_EMPRESAS = "setEmpresas";
export const SET_EMPRESA = "setEmpresa";

const state = {
    empresas: [],
    empresa:[],
}

const getters = {
    obtenerEmpresas(state) {
      return state.empresas;
    },
}

const actions = {
    async [OBTENER_EMPRESAS](context) {

        return new Promise(resolve => {
            ApiService.query("apiconsume/obtener?endpoint=api/Empresas", '')
                .then(({ data }) => {
                    context.commit(SET_EMPRESAS, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },

    

    async [OBTENER_EMPRESA](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Empresas/`)
                .then(({ data }) => {
                    context.commit(SET_EMPRESA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    


    },

    async [OBTENER_EMPRESA_DESCRIPCIONES](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Empresas/GetByIdDatosEmpresa/`)
                .then(({ data }) => {
                    context.commit(SET_EMPRESA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    


    },

    

    

    async [REGISTAR_EMPRESA](context, datosEmpresa){
        
        //console.log(datosEmpresa)
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Empresas`, datosEmpresa)
                .then(({ data }) => {
                    context.commit(SET_EMPRESA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },
    
    async [ACTUALIZAR_EMPRESA](context, datos){
        let id = datos.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Empresas/UpdateEmpresas/`, datos.datosEmpresa)
                .then(({ data }) => {
                    context.commit(SET_EMPRESA, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    }

  }

const mutations = {
    [SET_EMPRESAS](state, data) {
        state.empresas = data;
    },

    [SET_EMPRESA](state, data) {
        state.empresa = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}